import React, { useState, useEffect, useRef } from "react";
import { t } from "i18next";
import MenuIcon from "@mui/icons-material/Menu";
import CollapsibleNavbar from "./ReservedAreaDashboard/CollapseNavbar";
import { Logout } from "../UI/AppModal";
import { BookingApi } from "../../API/Apis/BookingApi";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

export default function WebHeader() {
  const [isLogged, setIsLogged] = useState(
    localStorage.getItem("isUserLoggedin")
  );
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [showMenu, setShowMenu] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  const { t: translate } = useTranslation();

  useEffect(() => {
    const handleStorageChange = () => {
      setIsLogged(localStorage.getItem("isUserLoggedin"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleProfileClick = () => {
    if (isSmallScreen) {
      if (isLogged === "true") {
        showNewIFrame("openCollapseNavbar");
      } else {
        handleLogin();
      }
    } else {
      setShowMenu((prev) => !prev);
    }
  };

  // Function to close navbar
  const closeNavbar = () => {
    if (isDrawerOpen) {
      showNewIFrame("hideCollapseNavbar");
      setIsDrawerOpen(false);
    }
  };
  const handleNavClick = (iframeId, isHomePage) => {
    closeNavbar();
    setCurrentPage(isHomePage);
    showNewIFrame(iframeId);
  };

  function handleLogout() {
    if (isLogged === null || isLogged === undefined || isLogged === "true") {
      BookingApi.logout();
      localStorage.setItem("isUserLoggedin", "false");
    } else {
      alert("you are already logged out");
    }
    setShowMenu(false);
    setOpen(false);
    closeNavbar();
  }

  function handleLogin() {
    if (isLogged === null || isLogged === undefined || isLogged === "false") {
      showNewIFrame("showSignInPage");
    } else {
      alert("you are already logged in");
    }
    setShowMenu(false);
  }

  const profileMenuRef = useRef<HTMLDivElement>(null);
  function getParentOrigin() {
    try {
      if (
        window.location.ancestorOrigins &&
        window.location.ancestorOrigins.length > 0
      ) {
        return window.location.ancestorOrigins[0];
      }
      if (document.referrer) {
        return new URL(document.referrer).origin;
      }
    } catch (error) {
      console.error("Error in getParentOrigin:", error);
      return "";
    }
  }

  const parentOrigin = getParentOrigin();
  const allowedOrigins = new Set([
    "https://mbrent.mercedes-benz.it",
    "https://bookingmerfina.mbrent.mercedes-benz.it",
    "https://mbrent.mercedes-benz.it/congaratulation",
    "https://merfinatestbooking.myrent.it",
    "https://mauroc147.myrent.it",
  ]);

  const targetOrigin =
    parentOrigin && allowedOrigins.has(parentOrigin) ? parentOrigin : "*";

  const showNewIFrame = (iframeFor) => {
    window.parent.postMessage(
      {
        event_id: iframeFor,
      },
      targetOrigin
    );
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        profileMenuRef.current &&
        !profileMenuRef.current.contains(event.target)
      ) {
        setShowMenu(false);
      }
    }

    if (showMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showMenu]);

  const [open, setOpen] = useState(false);

  const [currentPage, setCurrentPage] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const location = useLocation();
  const hash = location.hash;

  const handleClickOpen = () => {
    if (!currentPage || hash === "#dealer" || hash === "#contactUs") {
      handleLogouts();
    } else {
      scrollToTop();
      window.scrollTo(0, 0);
      showNewIFrame("showSignOutConfirmation");
      setOpen(true);
      setShowMenu(false);
      closeNavbar();
    }
  };

  function handleLogouts() {
    scrollToTop();
    window.scrollTo(0, 0);
    BookingApi.logout();
    localStorage.setItem("isUserLoggedin", "false");
    showNewIFrame("showSignInPage");
    setShowMenu(false);
    setCurrentPage(false);
    closeNavbar();
  }

  const scrollToTop = () => {
    window.parent.postMessage(
      {
        event_id: "scrollToTop",
      },
      targetOrigin
    );
  };

  const handleMenuClick = () => {
    if (isDrawerOpen) {
      showNewIFrame("hideCollapseNavbar");
      setIsDrawerOpen(false);
    } else {
      if (isLogged === "true") {
        showNewIFrame("openCollapseNavbar");
        setIsDrawerOpen(true);
      }
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
        }}
      >
        {!isSmallScreen && (
          <div
            style={{
              backgroundColor: "black",
              padding: "12px 30px",
              zIndex: 5000,
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
            }}
          >
            <div
              style={{
                maxWidth: "1462px",
                width: "100%",
                margin: "0 auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginTop: "34px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src="/assets/images/HeaderLogo.png"
                    alt="Mercedes Logo"
                    style={{
                      filter: "invert(1) brightness(1.5)",
                      height: "70px",
                      marginRight: "33px",
                    }}
                  />
                  <span
                    style={{
                      color: "white",
                      fontSize: "16px",
                      fontFamily: "MBCorpoAScreen1Cond-Regular-Web",
                      marginTop: "45px",
                    }}
                  >
                    Mercedes-Benz
                  </span>
                </div>

                <div style={{ position: "relative" }} ref={profileMenuRef}>
                  <img
                    src="/assets/images/proLogo.jpg"
                    alt="Profile"
                    style={{ height: "30px", width: "30px", cursor: "pointer" }}
                    onClick={handleProfileClick}
                  />
                  {showMenu && (
                    <div
                      style={{
                        position: "absolute",
                        right: 0,
                        top: "30px",
                        backgroundColor: "white",
                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                        padding: "10px",
                        zIndex: 100,
                        width: "161px",
                        fontSize: "15px",
                        fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                      }}
                    >
                      <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                        {isLogged === "true" ? (
                          <li
                            style={{
                              padding: "5px 10px",
                              cursor: "pointer",
                              color: "black",
                            }}
                            onClick={handleClickOpen}
                          >
                            {translate("Logout")}
                          </li>
                        ) : (
                          <li
                            style={{
                              padding: "5px 10px",
                              cursor: "pointer",
                              color: "black",
                            }}
                            onClick={handleLogin}
                          >
                            {translate("Login")}
                          </li>
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gap: "60px",
                  color: "white",
                  fontSize: "16px",
                  fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                  marginTop: "14px",
                  marginLeft: "19px",
                  paddingBottom: "20px",
                }}
              >
                {isLogged === "true" && (
                  <span style={{ width: "2%" }}>
                    <MenuIcon
                      style={{ cursor: "pointer" }}
                      onClick={handleMenuClick}
                    />
                    <CollapsibleNavbar
                      isDrawerOpen={isDrawerOpen}
                      toggleDrawer={toggleDrawer}
                    />
                  </span>
                )}
                <button
                  style={{
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: "white",
                    padding: 0,
                  }}
                  onClick={() => handleNavClick("showIFrameForBooking", true)}
                  id="home"
                >
                  {translate("Home")}
                </button>
                <button
                  style={{
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: "white",
                    padding: 0,
                  }}
                  onClick={() =>
                    handleNavClick("showNewIFrameForDealer", false)
                  }
                  id="dealer"
                >
                  {translate("Dealer")}
                </button>
                <button
                  style={{
                    cursor: "pointer",
                    background: "none",
                    border: "none",
                    color: "white",
                    padding: 0,
                  }}
                  onClick={() =>
                    handleNavClick("showNewIFrameForContact", false)
                  }
                  id="contactUs"
                >
                  {translate("Contact Us")}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {isSmallScreen && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            backgroundColor: "black",
            // padding: "10px",
            height: "47px",
            zIndex: "5000",
          }}
          className={"fixed top-0 left-0 right-0"}
        >
          <div style={{ width: "2%" }}>
            <CollapsibleNavbar
              isDrawerOpen={isDrawerOpen}
              toggleDrawer={toggleDrawer}
            />
          </div>
          <img
            src="/assets/images/MerLogo.png"
            alt="Logo"
            style={{ margin: "auto", height: "25px" }}
          />
          <div
            style={{ position: "relative", marginRight: "1rem" }}
            ref={profileMenuRef}
          >
            <img
              src="/assets/images/proLogo.jpg"
              alt="Profile"
              style={{ height: "19px", width: "19px", cursor: "pointer" }}
              onClick={handleProfileClick}
            />
            {showMenu && (
              <div
                style={{
                  position: "absolute",
                  right: 0,
                  top: "30px",
                  backgroundColor: "white",
                  boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                  borderRadius: "4px",
                  padding: "10px",
                  zIndex: 100,
                  width: "161px",
                  fontSize: "15px",
                  fontFamily: "MBCorpoSTitle-CondRegular-Web-new",
                }}
              >
                <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                  {isLogged == "true" ? (
                    <li
                      style={{
                        padding: "5px 10px",
                        cursor: "pointer",
                        color: "black",
                      }}
                      onClick={handleClickOpen}
                    >
                      {translate("Logout")}
                    </li>
                  ) : (
                    <li
                      style={{
                        padding: "5px 10px",
                        cursor: "pointer",
                        color: "black",
                      }}
                      onClick={handleLogin}
                    >
                      {translate("Login")}
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      )}
      {open && isLogged && (
        <Logout
          open={open}
          isSmallScreen={isSmallScreen}
          handleLogout={handleLogout}
          handleClose={handleClose}
        />
      )}
    </>
  );
}
